



















































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Local from '@/app/module/local'

@Component
export default class FieldSearch extends Vue {
  private searchText: string = this.$store.state.fieldState.fieldSearchText
  private status: string = this.$store.state.fieldState.fieldSearchStatus
  private variety: string = this.$store.state.fieldState.fieldSearchVariety
  private risk: any = this.$store.state.fieldState.fieldSearchRisk
  private statusList: {[key:string]: any} = []
  private varietyList: string[] = []
  private riskList: string[] = []
  private checkPlantOnly: boolean = this.$store.state.fieldState.plantingOnly
  public requesting: boolean = false

  // セレクトデータ追加
  private get selectBox (): boolean {
    return this.$store.state.setFlagState.selectDataListFlag
  }
  @Watch('selectBox')
  getSelectBoxData (flag: boolean) {
    if (flag) {
      this.getStatusList()
      this.getVarietyList()
      this.getRiskList()
    }
  }

  created () {
    if (this.$store.state.setFlagState.selectDataListFlag) {
      this.getStatusList()
      this.getVarietyList()
      this.getRiskList()
    }
  }

  /* 選択可能なステージを抽出 */
  private getStatusList () {
    let result = JSON.parse(Local.getGrowthStageData()!)
    this.statusList = result
  }

  /* 選択可能な品種を抽出 */
  private getVarietyList () {
    let result = JSON.parse(Local.getVarietiesData()!)
    this.varietyList = result
  }

  /* 選択可能なリスクを抽出 */
  private getRiskList () {
    let result = JSON.parse(Local.getRiskData()!)
    this.riskList = result
  }

  private doFieldSearch () {
    /* 絞り込み */
    this.risk = parseInt(this.risk)

    this.$store.commit('fieldState/setListRefile', this.checkPlantOnly)
    this.$store.commit('fieldState/setSearchStatus', this.status)
    this.$store.commit('fieldState/setSearchVariety', this.variety)
    this.$store.commit('fieldState/setSearchRisk', this.risk)
    this.$store.commit('fieldState/setSearchText', this.searchText)

    sessionStorage.removeItem('choiceFieldId')
    this.$emit('do-search')
  }

  private resetSearch () {
    this.checkPlantOnly = true
    this.status = ''
    this.variety = ''
    this.risk = 0
    this.searchText = ''

    /* stateリセット */
    this.$store.commit('fieldState/setListRefile', this.checkPlantOnly)
    this.$store.commit('fieldState/setSearchStatus', this.status)
    this.$store.commit('fieldState/setSearchVariety', this.variety)
    this.$store.commit('fieldState/setSearchRisk', this.risk)
    this.$store.commit('fieldState/setSearchText', this.searchText)
    this.$store.commit('fieldState/setAccordionType', 'district')

    sessionStorage.removeItem('choiceFieldId')
    this.$emit('reset-field-list')
  }
}
